module.exports = __webpack_public_path__ + "static/img/12023C_1_C_20220324_fit.9c98e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12023C_1_C_20220324_fit.png
// module id = sh1P
// module chunks = 0